module.exports = __webpack_public_path__ + "img/frame.d12eb94b.svg";